module.exports = __webpack_public_path__ + "img/lk.3ce70e50.svg";